import styled from 'styled-components';

export const Container = styled.div`
  .disabled {
    cursor: not-allowed;
    background-color: #ddd;
  }
`;
